<template>
 <div class="as-container as-container--border">
    <div class="as-box">
      <h1> Origin of visitors in the GTA </h1>
        <div class="as-body">
          <h2 class="h2">
            Total visitors
          </h2>
          <p class="as-title"> {{ this.displayNum(this.featureNb) }}</p>
        </div>
        <hr>
        <div class="as-body">
        <h2 class="h2">
          {{this.legendLabel}}
        </h2>
        <as-legend-color-continuous-polygon id="legend" orientation="horizontal" style="color:white;"></as-legend-color-continuous-polygon>
        <p class=""> <i>
          A visitor will be considered someone whose presence has been detected within an FSA which is not his/her residence
          </i>
        </p>
      </div>
    </div>
    <hr>
    <div class="as-box">
        <as-time-series-widget
            x-label="Date"
            y-label="Total visitors"
            responsive
            show-clear
          >
          </as-time-series-widget>
    </div>
    <hr>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Legend',
  data () {
    return {
      legendLabel: `Qty of visitors per FSA`
    }
  },
  computed: {
    ...mapState({
      featureNb: state => state.featureNb
    })
  },
  methods: {
    displayNum (val, style = {}) {
      const roundedValue = Math.round(val)
      const dollars = new Intl.NumberFormat('fr-CA', style).format(roundedValue)
      return dollars
    }
  }
}
</script>

<style>
as-legend-color-continuous-polygon .as-legend-color-continuous-polygon--outer-wrapper.as-legend-color-continuous-polygon--vertical {
    justify-content: space-evenly;
}
.as-panel__element {
  background: rgba(255,255,255,0.7) !important;
}
as-legend-color-continuous-polygon .as-legend-color-continuous-polygon--label {
    font-size: medium;
}

.as-sidebar .as-container {
    padding-left: 7px;
}
</style>
